export class IntervenantsFilters {
	nom: string = "";
	prenom: string = "";
	nomEntreprise: string = "";
	interne: boolean | null = null;
	travailleurDetache: boolean | null = null;
	statut: boolean | null = true;

	constructor() {
	}
}